export default __webpack_public_path__ + "static/media/PIN-GENERAL-CARD.233a1e13.png";